import {Trans} from '@lingui/macro';
import React from 'react';

import {SettingsCustomFieldsPagesEnum} from '../../../models/url/settingsUrlModel';

/*
 * Types.
 */

interface CustomFieldsResourceNameProps {
  tabPage: SettingsCustomFieldsPagesEnum;
  capitalizeFirstLetter?: boolean;
}

/*
 * Component.
 */

export const CustomFieldsResourceName = ({tabPage, capitalizeFirstLetter}: CustomFieldsResourceNameProps) => {
  switch (true) {
    case tabPage === SettingsCustomFieldsPagesEnum.CARDS && capitalizeFirstLetter:
      return <Trans id="custom-fields-resource-Contacts">Contacts</Trans>;
    case tabPage === SettingsCustomFieldsPagesEnum.CARDS && !capitalizeFirstLetter:
      return <Trans id="custom-fields-resource-contacts">contacts</Trans>;

    case tabPage === SettingsCustomFieldsPagesEnum.TEAMMATES && capitalizeFirstLetter:
      return <Trans id="custom-fields-resource-Teammates">Teammates</Trans>;
    case tabPage === SettingsCustomFieldsPagesEnum.TEAMMATES && !capitalizeFirstLetter:
      return <Trans id="custom-fields-resource-teammates">teammates</Trans>;

    case tabPage === SettingsCustomFieldsPagesEnum.INBOXES && capitalizeFirstLetter:
      return <Trans id="custom-fields-resource-Inboxes">Inboxes</Trans>;
    case tabPage === SettingsCustomFieldsPagesEnum.INBOXES && !capitalizeFirstLetter:
      return <Trans id="custom-fields-resource-inboxes">inboxes</Trans>;

    case tabPage === SettingsCustomFieldsPagesEnum.ACCOUNTS && capitalizeFirstLetter:
      return <Trans id="custom-fields-resource-Accounts">Accounts</Trans>;
    case tabPage === SettingsCustomFieldsPagesEnum.ACCOUNTS && !capitalizeFirstLetter:
      return <Trans id="custom-fields-resource-accounts">accounts</Trans>;

    default:
      return null;
  }
};
